/**
 * Which trains call at which stations: freight never; commuter and
 * regional trains at every station and halt; an intercity at some stations
 * and no halts; a high-speed train at fewer still. Which ones is fixed by
 * the station's name and the train, so a train calls at the same stations
 * every time it passes.
 *
 * Pure: `three/trains.ts` stops them.
 */

import type { TrainKind } from './consist.js';

export function callsAt(kind: TrainKind, s: { name: string; halt: boolean }, seed: number): boolean {
  if (kind === 'freight') return false;
  if (kind === 'commuter' || kind === 'regional') return true;
  if (s.halt) return false;
  const roll = unit(hash(s.name) ^ seed);
  return kind === 'intercity' ? roll < 0.5 : roll < 0.25;
}

function unit(h: number): number {
  return (Math.imul(h ^ (h >>> 15), 0x2c1b3c6d) >>> 0) / 4294967296;
}

function hash(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) h = Math.imul(h ^ s.charCodeAt(i), 16777619);
  return h >>> 0;
}
